import { action } from 'satcheljs/lib/legacy';
import { getUnifiedGroupDetailsPromiseOverride } from 'owa-groups-adaptors';
import { getUnifiedGroupDetails } from 'owa-groups-services';
import { isSuccess } from 'owa-groups-services';
import { setGroupSiteStatus } from 'owa-groups-shared-store';
import GroupSiteStatus from 'owa-groups-sharepoint-commands/lib/schema/GroupSiteStatus';
import UnifiedGroupDetails from 'owa-service/lib/contract/UnifiedGroupDetails';
import GetUnifiedGroupDetailsJsonResponse from 'owa-service/lib/contract/GetUnifiedGroupDetailsJsonResponse';
import addOrUpdateGroup from 'owa-groups-shared-store/lib/utils/addOrUpdateGroup';
import { getGroupsStore } from 'owa-groups-shared-store';
import addGroupSiteStatus from 'owa-groups-shared-store/lib/utils/addGroupSiteStatus';
import beforeGetGroupDetailsStartAction from './beforeGetGroupDetailsStartAction';

const parseUnifiedGroupDetailsResponse = (
    response: GetUnifiedGroupDetailsJsonResponse,
    groupSmtpAddress: string,
    onSuccessCallback?: () => void,
    onErrorCallback?: () => void
) => {
    if (!response || !response.Body || !isSuccess(response.Body)) {
        handleError(groupSmtpAddress, onErrorCallback);
        return;
    }

    const groupDetails: UnifiedGroupDetails = response.Body.GroupDetails;
    if (!groupDetails) {
        handleError(groupSmtpAddress, onErrorCallback);
        return;
    }

    addOrUpdateGroup(getGroupsStore(), groupDetails.SmtpAddress, {
        basicInformation: null,
        groupDetails: groupDetails,
        members: null /*Not available at this point*/,
        groupDetailsError: false,
    });

    addGroupSiteStatus(groupSmtpAddress, groupDetails);
    if (onSuccessCallback) {
        onSuccessCallback();
    }
};

const handleError = (groupSmtpAddress: string, onErrorCallback?: () => void) => {
    // #77190: this error should show up on the action bar
    addOrUpdateGroup(getGroupsStore(), groupSmtpAddress, {
        basicInformation: null,
        groupDetails: null,
        members: null,
        groupDetailsError: true,
    });

    // GroupSiteStatus is set to Provisioning in 'beforeGetGroupDetailsStartAction'
    // Resetting it to NotFound here when error is encountered
    setGroupSiteStatus(groupSmtpAddress, GroupSiteStatus.NotFound);

    if (onErrorCallback) {
        onErrorCallback();
    }
};

const getGroupDetailsAction = action('getGroupDetailsAction')(
    (
        groupSmtpAddress: string,
        loadFullDetails?: boolean,
        onSuccessCallback?: () => void,
        onErrorCallback?: () => void
    ) => {
        beforeGetGroupDetailsStartAction(groupSmtpAddress);
        const getter = getUnifiedGroupDetailsPromiseOverride || getUnifiedGroupDetails;
        getter(groupSmtpAddress, loadFullDetails)
            .then(result =>
                parseUnifiedGroupDetailsResponse(
                    result,
                    groupSmtpAddress,
                    onSuccessCallback,
                    onErrorCallback
                )
            )
            .catch(e => {
                handleError(groupSmtpAddress, onErrorCallback);
            });
    }
);

export default getGroupDetailsAction;
